module.exports = __webpack_public_path__ + "img/burger_icon_opened.98f7d4fd.svg";